import React, { FC, memo } from 'react';
import { BullSelector } from '../components';
const BullSelectorHBase: FC = _ => <BullSelector title="Bullselector - H" associationType="HOLSTEIN" data-sentry-element="BullSelector" data-sentry-component="BullSelectorHBase" data-sentry-source-file="bull-selector-h.tsx" />;

/**
 * Memoized Holstein bull selection screen.
 *
 * @returns The Holstein bull selector screen.
 */
export const BullSelectorH = memo(BullSelectorHBase);